import React, { useRef, useMemo } from "react";
import { extent } from "d3-array";
import { lab } from "d3-color";
import { interpolateCividis, scaleLinear, scaleSequential, scaleSqrt } from "d3";


import { XAxis, XAxisTitle, YAxis, YAxisTitle } from "./common/Axis";

import Density from "./HeatMap";

import { OrdinalLegend } from "./common/utils";
import Circles from "./common/Circles";
import "./common/Chart.css";


const ScatterPlot = ({ width = 650, height = 400, data, xAccessor, yAccessor, xLabel, yLabel, xFormatter, yFormatter, map, graphType }) => {

    console.log(data);

    //rAccessor, colorAccessor map
    const margin = { top: 50, right: 50, bottom: 50, left: 70 };
    const innerWidth = width - margin.left - margin.right;
    const innerHeight = height - margin.top - margin.bottom;

    // memoize the scales so we can optimize re-renders with React.memo

    const { xScale, yScale, rScale, colorScale } = useMemo(() => {
        if (!data) return {};

        const xExtent = extent(data, xAccessor);

        const yExtent = extent(data, yAccessor);

        // const rExtent = extent(data, rAccessor);
        //  const colorExtent = extent(data, colorAccessor);
        const xScale = scaleLinear().domain(xExtent).nice().rangeRound([0, innerWidth]);

        const yScale = scaleLinear().domain(yExtent).nice().rangeRound([innerHeight, 0]);

        // const rScale = scaleSqrt().domain(rExtent).range([1, 4]);
        const colorScale = scaleSequential(interpolateCividis).domain([1, 4]);

        return {
            xScale, rScale,
            yScale, colorScale,
        }
    }, [data, innerHeight, innerWidth, xAccessor, yAccessor, //rAccessor, colorAccessor
    ]);

    if (!data) return <div style={{ width, height }} />
    return (
        xScale && yScale && width && height ?

            <div className="relative">
                <svg width={width} height={height}>
                    <g transform={`translate(${margin.left} ${margin.top})`}>
                        <XAxis
                            xScale={xScale}
                            formatter={xFormatter}
                            title={xLabel}
                            height={height}
                            marginBottom={margin.bottom}
                            innerHeight={innerHeight}
                            gridLineHeight={innerHeight}
                        />
                        <YAxis
                            gridLineWidth={innerWidth}
                            yScale={yScale}
                            formatter={yFormatter}
                            title={yLabel}
                        />
                        <XAxisTitle
                            title={xLabel}
                            xScale={xScale}
                            innerHeight={innerHeight}
                        />
                        <YAxisTitle title={yLabel} />


                        <Density data={data}
                            xScale={xScale}
                            yScale={yScale}
                            showMap={map === 'heat' ? true : false}
                        />

                        <Circles
                            data={data}
                            xScale={xScale}
                            xAccessor={xAccessor}
                            yScale={yScale}
                            yAccessor={yAccessor}
                            colorScale={colorScale}
                            graphType={graphType}

                        />




                    </g>

                </svg>
                {/* <div className="mt-2">
                    <OrdinalLegend colorScale={colorScale} />
                </div> */}
            </div>
            : <div>"Scale not Defined "</div>
    )

}

//ScatterPlot.whyDidYouRender = true;
export default ScatterPlot;
